export function isMobile() {
  const userAgent = navigator.userAgent.toLowerCase();
  return /iphone|ipod|android|windows phone|blackberry|mobile/i.test(userAgent);
}

export function checkDeviceAndRedirect() {
  const isMobileDevice = isMobile();
  const currentPath = window.location.pathname;
  const isInMobilePath = currentPath.includes("/mobile/");

  if (isMobileDevice && !isInMobilePath) {
    window.location.href = currentPath.replace("/pc/", "/mobile/");
  }
}
